import { SERVICES_SITE_HOST } from '../siteConfig';
import { BrandConfig } from './types';

/**
 * The services site (spec 019): home turnovers, vehicle cleaning and Turo
 * handovers booked on a Provider's worker, Turno-style.
 *
 * Placeholder identity until the brand is decided: a neutral slate and green
 * palette, the default icons and draft policies in `public/policies/services/`.
 * Replace these together with the backend brand row (`brandSite` must match
 * it) when the domain and visuals are chosen.
 */
export const SERVICES_BRAND: BrandConfig = {
  id: 'services',
  brandSite: SERVICES_SITE_HOST,
  name: 'Autopilotee Services',
  siteTitle: 'Autopilotee Services',
  legalName: 'Jidosoju Holding Inc.',
  supportEmail: 'support@autopilotee.com',
  supportPhone: '',
  // Drafts for counsel: terms, cancellation, privacy, account deletion and the Provider agreement.
  policyBasePath: '/policies/services',
  policyTitles: { 'host-agreement': 'Provider Agreement' },
  assets: {
    favicon: '/favicon.ico',
    appleTouchIcon: '/logo192.png',
    manifest: '/manifest.json',
  },
  copy: {
    heroHeadline: 'Book a cleaner or a handover',
    heroSubcopy:
      'Turnover cleaning for your rental home, car cleaning and Turo key handovers from local Providers. See the price before you book.',
    about:
      'Autopilotee Services connects hosts and car owners with local Providers. Book a turnover clean between guests, a quick or deep clean for your car, or a worker who meets your Turo guest and hands over the keys. Each worker shows their service area, prices and on-time rate. You pick the date and a time window, and you see photos of the finished job.',
    metaDescription:
      'Autopilotee Services: turnover cleaning, car cleaning and Turo handovers from local Providers, with the price shown before you book.',
    // Services have no protection plans; the field is required by BrandCopy.
    protectionDescription: '',
  },
  theme: {
    primary: '#1F3A4D',
    primaryHover: '#152A39',
    primaryLight: '#2E5470',
    onPrimary: '#FFFFFF',
    accent: '#5FB49C',
    textPrimary: '#1B2630',
    textSecondary: '#5A6772',
    bg: '#FFFFFF',
    bgSecondary: '#F3F5F7',
    bgElevated: '#FFFFFF',
    border: '#DFE4E8',
    fontSans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontDisplay: "'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  showStagingPlaceholderName: false,
};
